module.exports = __webpack_public_path__ + "img/fk.9933c675.svg";